import TechnicalSpecifications from '../../../../components/specs/specs.desktop';
import technicalSpecifications from './technical-specifications';

export default technicalSpecifications(TechnicalSpecifications);
